module.exports = __webpack_public_path__ + "img/close.511cec05.svg";